class AuthHandler {
    constructor(baseURL, basicUsername, basicPassword) {
        this.baseURL = baseURL + "/auth";
        this.basicUsername = basicUsername;
        this.basicPassword = basicPassword;
    }

    getAuthorizationHeader() {
        const credentials = `${this.basicUsername}:${this.basicPassword}`;
        const base64Credentials = btoa(credentials);
        return {
            "Content-Type": "application/json",
            "Authorization": `Basic ${base64Credentials}`,
            Accepts: "application/json",
        };
    }

    async login(loginData) {
        try {
            const response = await fetch(`${this.baseURL}/login`, {
                method: "POST",
                headers: this.getAuthorizationHeader(),
                body: JSON.stringify(loginData),
            });
            const json = await response.json();
            if (response.ok) {
                return json; // Should return the token
            } else {
                console.error("Login failed:", json);
                return null;
            }
        } catch (error) {
            console.log("Backend not reachable", error);
            return null;
        }
    }

    async logout(token) {
        try {
            const response = await fetch(`${this.baseURL}/logout/${token}`, {
                method: "DELETE",
                headers: this.getAuthorizationHeader(),
            });
            const json = await response.json();
            if (response.ok) {
                return json; // Should return a success message
            } else {
                console.error("Logout failed:", json);
                return null;
            }
        } catch (error) {
            console.log("Backend not reachable", error);
            return null;
        }
    }

    async checkTokenAndRefresh(token) {
        try {
            const response = await fetch(`${this.baseURL}/checkTokenAndRefresh/`, {
                method: "PATCH",
                headers: this.getAuthorizationHeader(),
                body: JSON.stringify({token : token}),
            });
            const json = await response.json();
            if (response.ok) {
                if(json.token == null){
                    console.log(json.message);
                    return json;
                }
                return json; // Should return a success message
            } else {
                console.error("Logout failed:", json);
                return null;
            }
        } catch (error) {
            console.log("Backend not reachable", error);
            return null;
        }
    }
}

export default AuthHandler;